export function createRun(total: number, ms = 2400) {
  let shown = $state(0);
  let raf = 0;

  function start(onDone?: () => void) {
    cancelAnimationFrame(raf);
    shown = 0;
    const t0 = performance.now();
    const step = (t: number) => {
      shown = Math.min(total, Math.round(((t - t0) / ms) * total));
      if (shown < total) raf = requestAnimationFrame(step);
      else onDone?.();
    };
    raf = requestAnimationFrame(step);
  }

  return {
    get shown() {
      return shown;
    },
    get running() {
      return shown > 0 && shown < total;
    },
    get done() {
      return shown >= total;
    },
    start,
    finish: () => {
      cancelAnimationFrame(raf);
      shown = total;
    },
    stop: () => cancelAnimationFrame(raf)
  };
}
